import {
    getPaymentPagesFetchReducer,
    getPaymentPagesFeeTypesFetchReducer,
    postPaymentPagesFeeTypesCalculateReducer,
} from '../../slices/gq-admin/payment-pages';

export const gqAdminPaymentPagesReducers = {
    getPaymentPagesFetch: getPaymentPagesFetchReducer,
    getPaymentPagesFeeTypesFetch: getPaymentPagesFeeTypesFetchReducer,
    postPaymentPagesFeeTypesCalculate: postPaymentPagesFeeTypesCalculateReducer,
};
